// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSoneium } from "../../../icons/full/build/icon-soneium.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SoneiumIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSoneium.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SoneiumIcon.displayName = 'SoneiumIcon';
}

export default SoneiumIcon;